module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vheader'), _vm._v(" "), _c('vcreate')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-7437f4d6"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Create.vue
// module id = 155
// module chunks = 1